import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IInfoPanelButtonHOCProps } from './types';
import { getAsidePanelIsMobile } from '../../../../../asidePanel/store/selectors/getAsidePanelIsMobile';
import { onClick } from './events/onClick';
import { InfoPanelButton } from '../../components/InfoPanelButton/InfoPanelButton';
import { IInfoPanelButtonEvents, IInfoPanelButtonFields } from '../../components/InfoPanelButton/types';
import { INFO_TITLE } from '../../constants';

const mapStateToProps = (
    state: IApplicationState,
    { isShowTooltip }: IInfoPanelButtonHOCProps
): IInfoPanelButtonFields => {
    const isMobile = getAsidePanelIsMobile(state);
    const tooltip = isMobile
        ? null
        : isShowTooltip
            ? INFO_TITLE
            : null;
    return {
        tooltip,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { onClick: ownOnClick }: IInfoPanelButtonHOCProps
): IInfoPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const InfoPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(InfoPanelButton);
